export const successIcon = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="19px" height="19px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="嘉宾服务" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="商业化中心用户端H5/订单记录-订单详情-订单流程" transform="translate(-20.000000, -518.000000)" fill-rule="nonzero">
            <g id="Group-12" transform="translate(20.000000, 518.000000)">
                <circle id="Oval" fill="var(--primary-color)" cx="8" cy="8" r="8"></circle>
                <g id="Group-6" transform="translate(8.096451, 7.667518) rotate(-45.000000) translate(-8.096451, -7.667518) translate(4.596451, 5.697318)" fill="#FFFFFF">
                    <g id="Group-11" transform="translate(0.000000, -0.000000)">
                        <path d="M0.75,0 C1.16421356,-7.6089797e-17 1.5,0.335786438 1.5,0.75 L1.5,3.19040011 C1.5,3.60461368 1.16421356,3.94040011 0.75,3.94040011 C0.335786438,3.94040011 -4.54512677e-13,3.60461368 -4.54747351e-13,3.19040011 L-4.54747351e-13,0.75 C-4.54798077e-13,0.335786438 0.335786438,7.6089797e-17 0.75,0 Z" id="Rectangle"></path>
                        <rect id="Rectangle" x="9.09494702e-13" y="2.44040011" width="7" height="1.5" rx="0.75"></rect>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
